import { render } from "./NegociosFaq.vue?vue&type=template&id=36f0c479&scoped=true"
import script from "./NegociosFaq.vue?vue&type=script&lang=js"
export * from "./NegociosFaq.vue?vue&type=script&lang=js"

import "./NegociosFaq.vue?vue&type=style&index=0&id=36f0c479&lang=scss&scoped=true"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f0c479"]])

export default __exports__